import React from "react";
import SubscriptionPlan from "./_components/SubscriptionPlan";
import { useSearchParams } from "react-router-dom";
import RoleToggle from "../Dashboard/_components/RoleToggle";
import Plans from "./_components/Plans";
const roles = ["Subscription", "Plans"];
const Subscription: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("tab") || "Subscription";

  const handleRoleChange = (role: string) => {
    setSearchParams({ tab: role });
  };

  return (
    <>
      <div className="[@media(min-width:1920px)]:w-8/12 [@media(min-width:1536px)]:w-10/12  w-full mx-auto p-6 py-0 space-y-4 mb-6">
        <div className="flex flex-col justify-center items-center space-y-4">
          <h1 className="text-2xl text-[#212121] tracking-[-0.5px]">
            Subscription & Plans
          </h1>
          <RoleToggle
            options={roles}
            active={activeRole}
            onChange={handleRoleChange}
          />
        </div>

        {activeRole === "Subscription" && <SubscriptionPlan />}
        {activeRole === "Plans" && <Plans />}
      </div>
    </>
  );
};

export default Subscription;
